import React, { useState } from "react";
import LanguageSelect from "../components/smart/LanguageSelect";

const useTargets = ({ disabled = false } = {}) => {
  const [targets, setTargets] = useState([]);

  const buttonClicked = () => {
    setTargets((prev) => [...prev, { lang: "", langIso: "", col: "" }]);
  };

  const renderButton = () => (
    <div className="group">
      <button
        disabled={disabled}
        className="button button--safe"
        type="button"
        onClick={buttonClicked}
      >
        Add Target
      </button>
    </div>
  );

  const renderTargets = () => (
    <div className="group">
      {targets.map((target, index) => (
        <Target
          key={index}
          col={target.col}
          lang={target.lang}
          langIso={target.langIso}
          onInput={(e) => {
            const value = e.target.value;
            setTargets((prev) => {
              const copy = [...prev];
              copy[index] = { ...copy[index], col: value };
              return copy;
            });
          }}
          onChange={(e) => {
            const value = e.target.value;
            const langIso =
              e.target.selectedOptions?.[0]?.dataset?.codeIso || "";

            setTargets((prev) => {
              const copy = [...prev];
              copy[index] = { ...copy[index], lang: value, langIso };
              return copy;
            });
          }}
          disabled={disabled} // ✅ use destructured disabled, not props.disabled
        />
      ))}
    </div>
  );

  return [targets, renderButton, renderTargets, setTargets];
};

export default useTargets;

const Target = (props) => (
  <div className="double-inputs">
    <div className="group">
      <div className="label">Target lang</div>
      <LanguageSelect
        onChange={props.onChange}
        value={props.lang}
        selected={props.lang}
        disabled={props.disabled}
      />
    </div>
    <div className="group">
      <div className="label">Target col</div>
      <input
        type="text"
        className="input"
        onInput={props.onInput}
        value={props.col}
        disabled={props.disabled}
      />
    </div>
  </div>
);
